import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { IWGSharedService } from '../services/shared.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private userService: UserService, private sharedService: IWGSharedService, ) { }
    embedStatus = "notembed";  
    canActivate = () => {     
        var hasaccessToken = false;
        if (localStorage.getItem('accessToken'))
        {
            hasaccessToken = true;
        }
      
        if (this.sharedService.getIsEmbed())
        {       
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const embed = urlParams.get('embed');

            var hasaccessTokenIframe = false;
            if (localStorage.getItem('accessTokenCxp')) {
                hasaccessTokenIframe = true;
            }

            if (hasaccessTokenIframe == false) {
                console.log('embed = ' + embed)
                var userid = "";
                if (embed === "1") {
                    if (window.location && window.location.href && window.location.href.indexOf('myGuides') > 0) {
                        localStorage.setItem("NavigatePath", 'myGuides');
                    }
                    else if (window.location && window.location.href && window.location.href.indexOf('vendor-invoices') > 0) {
                        localStorage.setItem("NavigatePath", 'vendor-invoices');
                    }
                    userid = urlParams.get('UID');
                    localStorage.setItem("UID", userid);

                } else {
                    userid = localStorage.getItem('UID')
                }
                localStorage.setItem("UID", userid);

                if (userid && userid !== "") {
                    this.userService.getEmbedLoginToken(userid)
                        .subscribe((result) => {
                            if (result && result.data && result.data.text) {
                                localStorage.setItem("accessTokenCxp", result.data.text);
                                var path = localStorage.getItem('NavigatePath');
                                this.router.navigate([path]);
                                return true;
                            }
                            else {
                                return true;
                            }
                        });
                }
                console.log('hasaccessTokenIframe ' + hasaccessTokenIframe);
            } else {
                return true;
            }
        }
        else
        {               
            if (hasaccessToken === false) {
                this.router.navigate(['login']);                
            };
            return hasaccessToken;
        }
    };

    canLoad = () => {
        if (localStorage.getItem('accessToken')) {
            return true;
        }
        
        this.router.navigate(['login']);           
        return false;
    };
}
